import { getRaw, ApiResponse } from 'services/api';

export const INBOUND_SMS_URL = '/i/inboundSMS';

/**
 * Fetches inbound SMS messages
 */
export const getInboundSMSMessages = (): Promise<ApiResponse> => getRaw(INBOUND_SMS_URL);
